module.exports = __webpack_public_path__ + "static/img/7.ae11d86.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/2/zh/7.png
// module id = aVX8
// module chunks = 0